module.exports = __webpack_public_path__ + "img/bg_zd_l.a8d1279e.png";